/** Extract an 11-char YouTube video id from common watch / short / embed URLs. */
export function getYoutubeVideoId(url: string): string | null {
  if (!url) return null
  const match = url.match(
    /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|&v(?:i)?=))([^#&?]{11}).*/,
  )
  return match?.[1] ?? null
}

export function isYoutubeUrl(url: string | null | undefined): boolean {
  if (!url) return false
  return getYoutubeVideoId(url) != null
}

/** Hotlinked YouTube poster (reliable size; no oEmbed required). */
export function getYoutubeThumbnailUrl(videoId: string): string {
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
}

export type YoutubeEmbedParams = {
  rel?: 0 | 1
  modestbranding?: 0 | 1
  playsinline?: 0 | 1
  enablejsapi?: 0 | 1
  origin?: string
}

/** Build a youtube.com/embed URL with focus-oriented player params. */
export function getYoutubeEmbedUrl(
  videoId: string,
  params: YoutubeEmbedParams = {},
): string {
  const search = new URLSearchParams({
    rel: String(params.rel ?? 0),
    modestbranding: String(params.modestbranding ?? 1),
    playsinline: String(params.playsinline ?? 1),
    enablejsapi: String(params.enablejsapi ?? 1),
  })
  if (params.origin) {
    search.set('origin', params.origin)
  }
  return `https://www.youtube.com/embed/${videoId}?${search.toString()}`
}
